import {
  mainCartInitialState,
  type MainCartState,
} from '../CartPage/MainCart/interfaces/MainCartState';
import type { SpartacuxShoppingCartState } from '../ShoppingCartState';

export const selectMainCart = (
  state: SpartacuxShoppingCartState,
): MainCartState => state.shoppingCart?.carts?.main || mainCartInitialState;
